class AccordionSection extends HTMLElement {
  constructor() {
      super();
  }

  connectedCallback() {
      const sectionTemplate = this.getAttribute('data-section-template');

      if (sectionTemplate && sectionTemplate.includes('product')) {
          this.initializeCollapse(false); // Pass false to skip URL and scroll management
      } else {
          this.initializeCollapse(true);  // Pass true to manage URL and scroll
          this.handleUrlParameter();
      }
  }

  initializeCollapse(manageUrl) {
    console.log("loaded");
      const collapseBtns = this.querySelectorAll('[data-collapse-btn]');

      collapseBtns.forEach(collapseBtn => {
          collapseBtn.addEventListener('click', () => {
              if (manageUrl) {
                  const faqId = collapseBtn.getAttribute('id');
                  if (faqId) {
                      const url = new URL(window.location);
                      url.searchParams.set('faq', faqId);
                      window.history.replaceState(null, null, url);
                  }
              }
              collapseBtn.classList.toggle('collapsed');
          });
      });
  }

  handleUrlParameter() {
      const urlParams = new URLSearchParams(window.location.search);
      const faqId = urlParams.get('faq');
      const collapseBtns = this.querySelectorAll('[data-collapse-btn]');

      collapseBtns.forEach(collapseBtn => {
          if (faqId && collapseBtn.getAttribute('id') === faqId) {
              collapseBtn.classList.remove('collapsed');

              // Calculate the element's top position relative to the entire document
              const elementTop = collapseBtn.getBoundingClientRect().top + window.scrollY;

              // Center the element on the screen
              const scrollToY = elementTop - (window.innerHeight / 2) + (collapseBtn.offsetHeight / 2);

              // Scroll to the calculated position
              window.scrollTo({ top: scrollToY, behavior: 'smooth' });
          } else {
              collapseBtn.classList.add('collapsed');
          }
      });
  }
}

customElements.define('accordion-section', AccordionSection);


    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        e.preventDefault();
        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);
        const offset = 150; // adjust the offset here

        if (targetElement) {
          const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        }
      });
    });